import React from 'react';
import { CSSTransition } from 'react-transition-group';
import './welcom.scss'

const Welcome = (props) => {
    const handleClick = () => {
        props.onClick();
    }

    return (
        <CSSTransition
            unmountOnExit
            in={!props.in}
            timeout={{ appear: 1000, enter: 1000, exit: 300 }}
            classNames='welcome'
            appear
        >
            <div className="welcome-page">
                <p>Let's talk about <strong>Open Data</strong></p>
                <button onClick={handleClick}>Go!</button>
            </div>

        </CSSTransition>
    )
}

export default Welcome;